export async function generateQuestions(profile, level) {
  const systemPrompt = `
You are an expert technical interviewer creating ${level}-level interview questions for a ${profile}.
Generate exactly 15 questions — a mix of coding and objective types.
Return ONLY valid JSON array (no explanations, no text before or after).
Each item must have these fields:
{
  "type": "objective" | "coding",
  "question": "string",
  "options": ["A","B","C","D"], // if objective
  "correctAnswer": "string", // if objective
  "sampleInput": "string", // if coding
  "expectedOutput": "string" // if coding
}
`;

  try {
    const res = await fetch("https://api.openai.com/v1/chat/completions", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        model: "gpt-4o-mini",
        messages: [
          { role: "system", content: systemPrompt },
          {
            role: "user",
            content: `Generate ${level} ${profile} interview questions.`,
          },
        ],
        temperature: 0.6,
      }),
    });

    const data = await res.json();
    const content = data?.choices?.[0]?.message?.content?.trim() || "";

    // 🧹 Extract pure JSON content (handles extra text)
    const jsonMatch = content.match(/\[[\s\S]*\]/);
    if (!jsonMatch) {
      console.warn("No valid JSON array found in AI response:", content);
      return [];
    }

    const jsonText = jsonMatch[0];
    const parsed = JSON.parse(jsonText);

    // ✅ Ensure it’s an array
    if (Array.isArray(parsed)) {
      return parsed;
    } else {
      console.warn("Parsed result is not an array:", parsed);
      return [];
    }
  } catch (error) {
    console.error("Error generating questions:", error);
    return [];
  }
}
